import { createAddressButtonStyles } from "@insite/content-library/Widgets/Addresses/CreateAddressButton";
import { css } from "styled-components";

createAddressButtonStyles.overflowMenu = {
    cssOverrides:{
        wrapper:css`
            span {
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF;
            }
        `,
    }
}